import { of, switchMap } from 'rxjs';
import { provideBusyStateStream } from '@frontend-site/shared/core';
import { HybridCommunicationService } from './hybrid-communication.service';
import { HybridMessagePayloadService } from './hybrid-message-payload.service';

export const hybridMessagePayloadBusyStateProvider = provideBusyStateStream({
    deps: [HybridCommunicationService, HybridMessagePayloadService],
    useFactory: (hybridCommunication: HybridCommunicationService, hybridMessagePayload: HybridMessagePayloadService) =>
        /**
         * If the iframe is hidden, busy signals from the old ui should not intervene with the signals on the new ui.
         * The observable makes sure old ui busy signals are ignored when the iframe is hidden. The old ui still emits values,
         * but they are simply ignored here.
         * When the iframe is shown, the real busy stream is reintegrated. As `busy$` is a `BehaviorSubject`, it will reflect the real
         * current state of the old ui.
         *
         * Previously, the old ui caused the loading spinner to disappear when it should stay, and stay when it should disappear.
         **/
        hybridCommunication.shouldIgnoreOldUiSignals$.pipe(
            switchMap((hidingIframe: boolean) => (hidingIframe ? of(false) : hybridMessagePayload.busy$))
        )
});
